import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Contact() {
  const waLink = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`;
  return (
    <main data-testid="contact-page" className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
      <section className="pt-16 md:pt-24 pb-8 grid md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <div className="text-xs uppercase tracking-widest text-slate-500">Contact</div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.05] mt-2">
            Talk to our <span className="gfe-gradient-text">sourcing desk.</span>
          </h1>
          <p className="text-slate-600 mt-4 max-w-2xl">Reach out for quotes, catalogue enquiries, plant maintenance contracts or partnership discussions.</p>
        </div>
      </section>

      <section className="pb-12 grid lg:grid-cols-12 gap-6">
        {[
          { I: Phone, t: "Call us", v: SITE.phone, alt: SITE.phoneAlt, href: `tel:${SITE.phone}` },
          { I: Mail, t: "Email us", v: SITE.email, href: `mailto:${SITE.email}` },
          { I: MessageCircle, t: "WhatsApp", v: SITE.phone, href: waLink },
          { I: MapPin, t: "Visit us", v: SITE.address },
        ].map((c, i) => (
          <a
            key={i}
            href={c.href || "#"}
            target={c.href?.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            data-testid={`contact-card-${i}`}
            className="lg:col-span-3 md:col-span-6 col-span-12 group p-6 rounded-2xl border border-slate-200 bg-white hover:shadow-lg hover:-translate-y-0.5 transition"
          >
            <c.I className="w-5 h-5 text-orange-500" />
            <div className="text-xs uppercase tracking-widest text-slate-500 mt-4">{c.t}</div>
            <div className="font-display font-bold text-slate-900 mt-1.5 leading-tight">{c.v}</div>
            {c.alt && <div className="text-sm text-slate-500 mt-1">{c.alt}</div>}
          </a>
        ))}
      </section>

      <section className="pb-20 grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7 rounded-3xl overflow-hidden border border-slate-200">
          <iframe
            title="Green Fuse Energy location"
            width="100%"
            height="420"
            style={{ border: 0 }}
            loading="lazy"
            src={`https://www.google.com/maps?q=${encodeURIComponent("Rewari, Haryana 123401 India")}&output=embed`}
          />
        </div>
        <div className="lg:col-span-5">
          <div className="p-6 md:p-8 rounded-3xl bg-slate-50 border border-slate-200">
            <div className="text-xs uppercase tracking-widest text-slate-500">Working hours</div>
            <div className="flex items-center gap-3 mt-3">
              <Clock className="w-5 h-5 text-slate-900" />
              <div>
                <div className="font-display font-bold text-slate-900">Mon – Sat · 9:00 AM – 7:00 PM IST</div>
                <div className="text-sm text-slate-500">Sunday closed · Urgent RFQs answered on WhatsApp</div>
              </div>
            </div>
            <hr className="my-6 border-slate-200" />
            <div className="text-xs uppercase tracking-widest text-slate-500">Registered office</div>
            <div className="mt-2 text-slate-800 font-medium leading-relaxed">{SITE.address}</div>
            <div className="text-xs text-slate-500 mt-2">GSTIN: {SITE.gstin}</div>
          </div>
        </div>
      </section>
    </main>
  );
}
